/*
 * File: /src/services/actionsServices.js
 * Created Date: Saturday June 15th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 16th June 2019 10:38:36 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import { authedAxios } from 'src/shared/axiosWrapper';
import { AD_BASE_ACTIONS_PATH } from '../constants';

export default {
  fetchActions() {
    return authedAxios.get(AD_BASE_ACTIONS_PATH);
  },
  saveNewAction(actionMeta) {
    return authedAxios.post(AD_BASE_ACTIONS_PATH, actionMeta);
  },
  fetchActionTypes() {
    // TODO: Make this a real call eventually
    // for now just keep the same contract
    return Promise.resolve({
      data: {
        email: 'Email',
        sms: 'SMS',
        wait: 'Wait'
      }
    });
  }
};
